module.exports = __webpack_public_path__ + "img/Facebook.342d2170.svg";